<template>
    <div class="meterReading">
        <div class="title">远程抄表</div>
        <div class="warp" v-show="!isEdit">
            <div class="tableTab">
                <div :class="tableIdx == index? 'tableItem se':'tableItem'" v-for="(item,index) in template" :key="item.id" @click="select(index)">
                    {{item.name}}
                </div>
            </div>
            <div class="tableHead">
                <div class="search">
                    <el-input type="search" v-model.trim="searchValue"   @change="theInput"  placeholder="输入表号、表名以搜索"></el-input>
                    <i class="el-icon-search" ></i>
                </div>
                <TimePicker :type="TimePickerType" @countWeek="countWeek"  @sendTime="sendTime" v-if="show"/>
                <div class="meterFrequency">
                    抄表频次：<span>{{meterFrequency}}</span>
                    <div class="edit">
                        <div class="btn" @click="editTable()">
                            <img src="https://www.energydt.cn/proxy/ebs-uniapp/edit.png" alt="">编辑
                        </div>
                        <div class="btn" @click="downLoad">
                            <img src="https://www.energydt.cn/proxy/ebs-uniapp/downLoad.png" alt="">下载
                        </div>
                    </div>
                </div>
            </div>
            <div class="tableConcent" >
                <div class="warp" v-if="tableData.length > 0 && isRequest == false">
                    <el-table
                    :data="tableData"
                    style="width: 100%;height:100%;"
                    height="610"
                    :header-cell-style='{background: "#FAFAFA"}'>
                        <el-table-column
                            :prop="item.prop"
                            :label="item.label"    
                            v-for="item in currentTable.tableConfig" :key="item.id">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="warp" v-if="tableData.length == 0 && isRequest == true">
				    <Loading LoadingId="mulberryLoading" :scale="0.5" />
                </div>
                <div class="warp" v-if="tableData.length == 0 && isRequest == false">
				    <div class="nothing" >
                        <img src="../../assets/img/not_found_data.png" alt="">
                    </div>
                </div>
            </div>
            <div class="total">
                <div class="title">总计</div>
                <div class="totalCon">
                    <div class="electric">
                        <div class="left">
                            <img src="https://www.energydt.cn/proxy/ebs-uniapp/electric.png" alt="">电
                        </div>
                        <div class="right">
                            <div class="centerCon">
                                <div class="use">上期：{{total.electric.old }}<span> kwh</span></div>
                                <div class="use">本期：{{total.electric.first }} <span> kwh</span></div>
                                <div class="use">{{total.electric.precent.indexOf('+') !== -1?'同比增加：'+ total.electric.precent:'同比减少：' + total.electric.precent}} <span> %</span></div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="electric">
                        <div class="left">
                            <img src="https://www.energydt.cn/proxy/ebs-uniapp/water.png" alt="">水
                        </div>
                        <div class="right">
                            <div class="centerCon">
                                <div class="use">上期：{{total.water.old}} <span> m³</span></div>
                                <div class="use">本期：{{total.water.first }} <span> m³</span></div>
                                <div class="use">{{total.water.precent.indexOf('+') !== -1?'同比增加：'+ total.water.precent:'同比减少：' + total.water.precent}} <span> %</span></div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Edit :templateList="template" :tableConfig="tableConfigs" @close="close" :idx="tableIdx" :currentTime="currentTime" :meterList="meters"
         :countWeek="countWeekTime" @selectFre="selectFre"  v-if="isEdit" />
    </div>
</template>

<script>
const TimePicker = ()=>import('../../components/common/TimePicker.vue')
const Edit = ()=>import('./components/Edit.vue')
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'
import { _getMeterTemplate, _getMeterTemplateData } from '../../api/power'
import { perDay, perMonth, getAppointedDate, dayStart, dayEnd, weekEnd, weekStart, monthEnd, monthStart } from "../../util/DateUtil";
import Loading from '../../components/common/Loading.vue'
export default {
    data(){
        return {
            tableIdx:0,
            searchValue:'',
            isEdit:false,
            isRequest:true,
            total:{
                water:{
                    first:'--',
                    old:'--',
                    precent:'--'
                },
                electric:{
                    first:0,
                    old:0,
                    precent:'100'
                }
            },
            TimePickerType:'month',
            currentTable:{},
            currentTime:'',
            countWeekTime:'',
            meterFrequency:'一月一次',
            tableConfigs:[
                {
                    idx:1,
                    label:'表号',
                    prop:'meterNo'
                },
                {
                    idx:2,
                    label:'表计名称',
                    prop:'meterName'
                },
                {
                    idx:3,
                    label:'表类型',
                    prop:'meterType'
                },
                {
                    idx:4,
                    label:'上期用量',
                    prop:'lastMonthElectric'
                },
                {
                    idx:5,
                    label:'本期用量',
                    prop:'currentMonthElectric'
                },
                {
                    idx:6,
                    label:'同比增加/减少',
                    prop:'incDec'
                },
                {
                    idx:7,
                    label:'本期起码',
                    prop:'start'
                },
                {
                    idx:8,
                    label:'本期止码',
                    prop:'end'
                },
                {
                    idx:9,
                    label:'上期起码',
                    prop:'lastFirstVal'
                },
                {
                    idx:10,
                    label:'上期止码',
                    prop:'lastLastVal'
                },
                {
                    idx:11,
                    label:'上期金额',
                    prop:'lastAmount'
                },
                {
                    idx:12,
                    label:'本期金额',
                    prop:'thisAmount'
                },
            ],
            template:[],
            meters:[],
            tableData: [],
            tableDataDefault:[],
            show:true
        }
    },
    components:{
        TimePicker, Edit, Loading
    },
    computed:{
        nowDateText(){
            let time = this.currentTime.split('-')
            let now = ''
            switch(this.meterFrequency){
                case '一月一次':
                    now = `${time[0]}年${time[1]}月`
                    break;
                case '一周一次':
                    now = this.getWeek(this.countWeekTime)
                    break;
                case '一日一次':
                    now = `${time[0]}年${time[1]}月${time[2]}日`
                    break;
            }
            return now
        },
    },
    watch:{
        nowDateText(val){
            // console.log(this.countWeekTime);
            if(this.template.length > 0){
                this.getTemplateData(this.currentTable)
            }
        }
    },
    mounted(){
        this.getTemplate()
    },
    methods:{
        select(idx){
            let _this = this
            this.tableIdx = idx
            
            this.currentTable = this.template[idx]
            // console.log(this.currentTable);
            this.formatFre(this.currentTable.cycle)
            this.show = false
            setTimeout(()=>{
                _this.show = true
            }, 0)
            this.getTemplateData(this.currentTable)
            
        },
        getWeek(val){
            
            let firstDay = new Date(val.getFullYear(), 0, 1)  // 当前年份的第一天
            let dayOfWeek = firstDay.getDay()  // 当前年份的第一天是周几
            let spendDay = 1
            if(dayOfWeek !=0){
                spendDay = 7 -dayOfWeek + 1  // 距离下周还有几天
            }
            
            firstDay = new Date(val.getFullYear(), 0, 1 + spendDay)

            let d = Math.ceil((val.valueOf() - firstDay.valueOf()) / 86400000)
            
            let result = Math.ceil(d / 7)
            let year = val.getFullYear()
            let week = result 
            if(dayOfWeek !== 0){
                week = result + 1
            }
            if(week === 53 && val.getDate() !== 26){
                week = 1
                year += 1
            }
            if(week === 0){
                week = 52
                year -= 1
            }
            return `${year}年第${week}周`
        },
        formatFre(cycle){
            switch(cycle){
                case 'month':
                    this.meterFrequency = '一月一次'
                    this.TimePickerType = 'month'
                    break;
                case 'week':
                    this.meterFrequency = '一周一次'
                    this.TimePickerType = 'week'
                    break;
                case 'day':
                    this.meterFrequency = '一日一次'
                    this.TimePickerType = 'date'
                    break;
            }
        },
        theInput(e){
            // console.log(e);
            let arr = []
            this.tableDataDefault.forEach(item =>{
                if((item.meterNo + '').indexOf(e) != -1 || item.meterName.indexOf(e) != -1){
                    // console.log(item);
                    arr.push(item)
                }
            })
            this.tableData = arr
            
        },
        sendTime(time){
            // console.log(time);
            this.currentTime = time
            // if(this.template.length > 0){
            //     this.getTemplateData(this.currentTable)
            // }
        },
        editTable(){
            this.isEdit = true
        },
        close(idx){
            let _this = this
            this.tableIdx = idx
            this.isEdit = false
            this.isRequest = true
            this.tableData = []
            setTimeout(()=>{
                _this.getTemplate()
                // console.log(_this.currentTime);
            }, 500)
        },
        selectFre(fre){
            this.meterFrequency = fre
            switch(fre){
                case '一月一次':
                    this.TimePickerType = 'month'
                    break;
                case '一周一次':
                    this.TimePickerType = 'week'
                    break;
                case '一日一次':
                    this.TimePickerType = 'date'
                    break;
            }
        },
        countWeek(val){
            this.countWeekTime = val
        },
        async getTemplate(){
            
            let _this = this
            try{
                let res = await _getMeterTemplate({
                    projectId:this.$store.getters.projectId
                })
                // console.log(res);
                if(res.data.data.template.length>0){
                    this.template = res.data.data.template.map(item =>{
                        let configs = item.headers.map(head =>{
                            let config = _this.tableConfigs.find(con=>con.label == head.name)
                            head.prop = config.prop
                            head.label = head.name
                            return head =  {
                                prop:config.prop,
                                label:head.name,
                                id:head.id
                            }
                        })
                        
                        
                        
                        return item = {
                            name:item.name,
                            id:item.id,
                            cycle:item.cycle,
                            tableConfig:configs,
                            loops:item.loops,
                            editHeader:false,
                            editMeter:false
                        }
                    })
                }else{
                    this.template = []
                    this.isRequest = false
                }
                this.meters = res.data.data.loops.map(item =>{
                    return item = {
                        meterNo: item.loopId,
                        loopId:item.loopId,
                        meterType: item.loopType == 'WATER'?'水表':'电表',
                        meterName: item.loopName,
                        isInput:false
                    }
                })
                this.select(this.tableIdx)
                
            }catch(err){
                // console.log(err)
            }
            
        },
        
        async getTemplateData(tem){
            this.tableData = []
            let _this = this
            this.isRequest = true
            let httpTime = this.formatHttpTime(tem.cycle)
            // console.log(httpTime);
            // return 
            try{
                let res = await _getMeterTemplateData({
                    start:httpTime.start,
                    end:httpTime.end,
                    lastStart:httpTime.lastStart,
                    lastEnd:httpTime.lastEnd,  
                    projectId:this.$store.getters.projectId,
                    templateId:tem.id,
                    type:tem.cycle
                })
                // console.log(res);

                let arr = res.data.data.date.map(item =>{
                    let precent = _this.precent(item.thisUsage, item.lastUsage)
                    
                    return item = { 
                        meterNo:item.loop.loopId,
                        meterName:item.loop.loopName,
                        meterType:item.type,
                        lastMonthElectric:Number(item.lastUsage).toFixed(2),
                        currentMonthElectric:Number(item.thisUsage).toFixed(2),
                        incDec:precent,
                        start: typeof item.firstVal == 'number'? Number(item.firstVal).toFixed(2) : '--',
                        end: typeof item.lastVal == 'number'? Number(item.lastVal).toFixed(2): '--',
                        lastFirstVal:typeof item.lastFirstVal == 'number'? Number(item.lastFirstVal).toFixed(2): '--',
                        lastLastVal:typeof item.lastLastVal == 'number'? Number(item.lastLastVal).toFixed(2): '--',
                        lastAmount:typeof item.lastAmount == 'number'? Number(item.lastAmount).toFixed(2): '--',
                        thisAmount:typeof item.thisAmount == 'number'? Number(item.thisAmount).toFixed(2): '--'
                    }
                })
                this.tableData = arr
                this.tableDataDefault = arr

                let waterPre = _this.precent(res.data.data.waterCount, res.data.data.lastWaterCount)
                let electricPre = _this.precent(res.data.data.electricCount, res.data.data.lastElectricCount)
                let total = {
                    water:{
                        first:res.data.data.waterCount == 0?'--':Number(res.data.data.waterCount).toFixed(2),
                        old:res.data.data.lastWaterCount == 0?'--':Number(res.data.data.lastWaterCount).toFixed(2),
                        precent:waterPre.replace('%', '')
                    },
                    electric:{
                        first:Number(res.data.data.electricCount).toFixed(2),
                        old:Number(res.data.data.lastElectricCount).toFixed(2),
                        precent:electricPre.replace('%', '')
                    }
                }
                this.total = total 
                this.isRequest = false
            }catch(err){
                // console.log(err);
            }
            
        },
        formatHttpTime(type){
            let start = ''
            let end = ''
            let lastStart = ''
            let lastEnd = ''

            switch(type){
                case 'day':
                    start = dayStart(this.countWeekTime)
                    end = dayEnd(this.countWeekTime)
                    lastStart = this.perD().start
                    lastEnd = this.perD().end
                    break;
                case 'week':
                    start = weekStart(this.countWeekTime)
                    end = weekEnd(this.countWeekTime)
                    lastStart = this.perW().start
                    lastEnd = this.perW().end
                    break;
                case 'month':
                    start = monthStart(this.countWeekTime)
                    end = monthEnd(this.countWeekTime)
                    lastStart = this.perM().start
                    lastEnd = this.perM().end
                    break;
            }
            return {
                start, end, lastStart, lastEnd
            }
        },
        
        perD() {
			return {
                start:dayStart(perDay(this.countWeekTime)),
                end:dayEnd(perDay(this.countWeekTime))
            }
		},
        perW() {
			let week = getAppointedDate(this.countWeekTime, 1, 1);
			return {
                start:weekStart(new Date(week.startDate)) ,
                end:weekEnd(new Date(week.startDate)) 
            }
		},
        perM() {
			return {
                start:monthStart(perMonth(this.countWeekTime)),
                end:monthEnd(perMonth(this.countWeekTime))
            }
		},
        precent(val, old){
            let spread = 0
            if(val == 0 && old == 0) return  ' --%'
            if(old == 0) return '+ 100%'

            if(val > old){
                spread = '+ ' + Number((val - old) / old*100).toFixed(2) 
            }else{
                spread = '- ' + Number((Math.abs(val - old)*100) / old).toFixed(2) 
            }
            
            return spread + '%'
        },
        downLoad(){
            if (this.tableData.length > 0) {
                
                let tabconfigs = this.currentTable.tableConfig.map(item =>item = item.label)
                // return
                let data = [ tabconfigs ]


                this.tableData.forEach(d => {
                    let meterconfig = [...this.currentTable.tableConfig.map(item =>item = d[item.prop])]
                    data.push(meterconfig)
                })
                
                const workbook = new ExcelJS.Workbook();
                // 创建带有红色标签颜色的工作表
                const sheet = workbook.addWorksheet('Sheet1');

                let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'].filter((h,i)=>i<tabconfigs.length)
                

                // console.log(this.nowDateText);
                // return
                let sheetName = [this.nowDateText + "抄表单"]
                
                    let style =  {
                        fill: {
                            type: 'gradient',
                            gradient: 'angle',
                            degree: 0,
                            stops: [
                            { position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
                            { position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
                            { position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
                            ]
                        },
                        font20:{
                            name: 'Arial',
                            size: 20,
                            bold: true
                        },
                        font12bold:{
                            name: 'Arial',
                            size: 12,
                            bold: true
                        },
                        font12:{
                            name: 'Arial',
                            size: 12,
                            // bold: true
                        },
                        alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
                        alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
                        border:{
                            top: {style:'thin'},
                            left: {style:'thin'},
                            bottom: {style:'thin'},
                            right: {style:'thin'}
                        }
                    }

                    //处理一二层
        
                    sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
                    sheet.getCell(letter[0]+'1').value = sheetName[0]
                    sheet.getCell(letter[0]+'1').font = style.font20
                    sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
                    
                    
                    const rows = sheet.getRows(1, 2);
                    rows.map(e=>{e.height = 50 ;return e})

                    //表格设置
                    let columns = []
                    data[0].forEach(item=>{
                        columns.push({
                            name:item,
                        })
                    })
                    
                    sheet.addTable({
                        name: 'MyTable',
                        ref: 'A2', // 表格左上角的位置
                        headerRow: true,
                        totalsRow: false,
                        style: {
                            theme: 'TableStyleLight1',
                            font:{
                                name: 'Arial',
                                size: 12,
                                // bold: true
                            },
                        },
                            //            showRowStripes: true,
                        columns:columns,
                        rows: data.slice(1),
                    })

                    //表格头部样式
                    sheet.getRow(2).height = 59
                    sheet.getRow(2).font=style.font12bold
                    
                    letter.forEach(item=>{
                        sheet.getCell(item+'2').fill = style.fill
                        sheet.getCell(item+'2').border = style.border
                        sheet.getRow(2).alignment = style.alignmentCenter
                    })
                    data.slice(1).forEach((item,index)=>{
                        sheet.getRow(3+index).height = 38
                        sheet.getRow(3+index).font=style.font12
                        letter.forEach((e,i)=>{
                            sheet.getColumn(e).width = 30
                            sheet.getCell(e+(3+index)).border = style.border
                        })
                    
                        sheet.getRow(3+index).alignment = style.alignmentCenter
                    })
                    
                    sheet.mergeCells('A'+(3+data.slice(1).length)+':A'+(4+data.slice(1).length));
                    sheet.getCell('A'+(3+data.slice(1).length)).value = "总计"
                    sheet.getCell('B'+(3+data.slice(1).length)).value = "电"
                    sheet.getCell('C'+(3+data.slice(1).length)).value = "上期："+this.total.electric.old+" kwh"
                    sheet.getCell('D'+(3+data.slice(1).length)).value = "本期："+this.total.electric.first+" kwh"
                    sheet.getCell('E'+(3+data.slice(1).length)).value = this.total.electric.precent.indexOf('+') !== -1?'同比增加：'+ this.total.electric.precent+" %":'同比减少：' + this.total.electric.precent+" %"

                    sheet.getCell('B'+(4+data.slice(1).length)).value = "水"
                    sheet.getCell('C'+(4+data.slice(1).length)).value = "上期："+this.total.water.old+" m³"
                    sheet.getCell('D'+(4+data.slice(1).length)).value = "本期："+this.total.water.first+" m³"
                    sheet.getCell('E'+(4+data.slice(1).length)).value = this.total.water.precent.indexOf('+') !== -1?'同比增加：'+ this.total.water.precent+" %":'同比减少：' + this.total.water.precent+" %"
                    
                    sheet.getRow(3+data.slice(1).length).height = 38
                    sheet.getRow(3+data.slice(1).length).font=style.font12bold
                    sheet.getRow(3+data.slice(1).length).border=style.border
                    sheet.getRow(3+data.slice(1).length).alignment = style.alignmentCenter
                    
                    sheet.getRow(4+data.slice(1).length).height = 38
                    sheet.getRow(4+data.slice(1).length).font=style.font12bold
                    sheet.getRow(4+data.slice(1).length).border=style.border
                    sheet.getRow(4+data.slice(1).length).alignment = style.alignmentCenter

                    // sheet.getRow(data.length + 2).height = 50
                    // sheet.getRow(data.length + 2).font=style.font12

                workbook.xlsx.writeBuffer().then(buffer => {
                    FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
                })
            } else {
                this.$message.warning("无图表数据！")
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .meterReading{
        width: 100%;
        height: 100%;
        background: #fff;
        padding:0 17rem 17rem;
        .title{
            padding: 17rem 0;
            font-size: 18rpx;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
        }
        .tableTab{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            height: 40rem;
            .tableItem{
                width: 152rem;
                height: 40rem;
                line-height: 40rem;
                text-align: center;
                // padding-left: 15rem;
                background: #FFFFFF;
                border: 1px solid #999999;
                border-radius: 2px;
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                margin-right: 8rem;
                cursor: pointer;
            }
            .se{
                background: #0E9CFF;
                border: 1px solid #0E9CFF;
                color: #fff;
            }
        }
        .tableHead{
            height: 75rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .search{
                width: 240rem;
                height: 40rem;
                background: #FFFFFF;
                border: 1px solid #CCCCCC;
                border-radius: 2px;
                position: relative;
                
                /deep/.el-input__inner {
                    width: 90% !important;
                    height: 37rem;
                    border: none;
                    padding: 0 0 0 0.5vw;
                    &::placeholder{
                        font-size: 12rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #CCCCCC;
                    }
                }
                /deep/ input[type="search"]::-webkit-search-cancel-button{
                    display: none;
                }
                &>i{
                    position: absolute;
                    right: 0.2vw;
                    top: 50%;
                    transform: translate(0, -50%);
                    color: #666;
                    cursor: pointer;
                }
            }
            .meterFrequency{
                padding-right: 150rem;
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #666666;
                position: relative;
                &>span{
                    color: #333;
                }

                .edit{
                    height: 100rem;
                    width: 100rem;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    
                    .btn{
                        width: 100rem;
                        height: 40rem;
                        line-height: 40rem;
                        text-align: center;
                        background: #0D94FF;
                        border-radius: 2px;
                        font-size: 18rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        cursor: pointer;
                        &>img{
                            width: 15rem;
                            height: 15rem;
                            margin-right: 5rem;
                        }
                    }
                }
            }
        }
        .tableConcent{
            height: 700rem;
            position: relative;
            .noshowData{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 18rem;
            }
            .warp{
                height: 100%;
                width: 100%;
                
               .nothing{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    &>img{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                
                /deep/.el-table{
                    height: calc(100% - 6rem);
                }

                /deep/.el-table th>.cell {
                    color:#333;
                    
                }
                /deep/.el-table__header{
                    border-bottom: 1px solid #EBEBEB; 
                }
                /deep/.el-table td, .el-table th.is-leaf {
                    border-bottom: none; 
                }
            }
        }
        .total{
            height: 96rem;
            background: #FFFFFF;
            box-shadow: 0px 2px 12px 0px rgba(0,51,92,0.14);
            border-radius: 2px;
            display: flex;
            .title{
                width: 80rem;
                height: 96rem;
                line-height: 96rem;
                text-align: center;
                padding: 0;
                font-size: 24rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #333333;
            }
            .totalCon{
                width: calc(100% - 80rem);
                height: 100%;
                .electric{
                    display: flex;
                    height: 50%;
                    .left{
                        width: 51rem;
                        height: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 20rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #666666;
                        &>img{
                            width: 21rem;
                            height: 21rem;
                        }
                    }
                    .right{
                        width: 1150rem;
                        height: 100%;    
                        position: relative;
                        .centerCon{
                            width: 100%;
                            height: 100%;   
                            // position: absolute;
                            // top: 50%;
                            // left: 50%;
                            // transform: translate(-50%, -50%);
                            display: flex;
                            align-items: center;
                            // padding-left: 70rem;
                            justify-content: space-evenly;
                            .use{
                                width: 250rem;
                                white-space: nowrap;
                                margin-right: 40rem;
                                font-size: 24rem;
                                font-family: Source Han Sans CN;
                                font-weight: 400;
                                color: #333333;
                                &>span{
                                    font-weight: bold;
                                    font-style: italic;
                                }
                            }
                        }
                    }
                }
                .electric:first-child{
                    border-bottom: 1px dashed #CCCCCC;
                }
            }
        }
    }
    /deep/ .el-table::before {
        height: 0;
    }

</style>